import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/app/ui/assets/svg/warning-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_location_pin.svg'
import _imports_2 from '@/app/ui/assets/svg/ill_spot_unavailable_location.svg'


const _hoisted_1 = { "data-testid": "pickup-request-modal" }
const _hoisted_2 = { class: "flex flex-col gap-y-4 w-full" }
const _hoisted_3 = {
  key: 0,
  "data-testid": "pickup-request-modal-bucket-banner",
  class: "w-full bg-yellow-lp-400 border border-yellow-lp-1300 rounded-lg px-4 py-3 flex items-center justify-between"
}
const _hoisted_4 = { class: "text-sm text-gray-lp-300" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = {
  key: 1,
  "data-testid": "pickup-request-modal-awb-card",
  class: "w-full bg-white border border-red-lp-2800 rounded-lg px-4 py-3"
}
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", {
  class: "text-sm text-black-lp-100 font-normal",
  "data-testid": "pickup-request-modal-awb-card-label"
}, " Ready to Pick Up ", -1)
const _hoisted_9 = { class: "flex items-baseline gap-1 mt-1" }
const _hoisted_10 = {
  class: "text-xl font-bold text-black-lp-300",
  "data-testid": "pickup-request-modal-awb-card-count-awb"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "AWB", -1)
const _hoisted_12 = {
  class: "text-sm text-black-lp-100",
  "data-testid": "pickup-request-modal-awb-card-count-koli"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "text-sm text-gray-lp-600 mx-1" }, "•", -1)
const _hoisted_14 = {
  class: "text-xl font-bold text-black-lp-300",
  "data-testid": "pickup-request-modal-awb-card-count-weight"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "kg", -1)
const _hoisted_16 = {
  key: 2,
  "data-testid": "pickup-request-modal-awb-limit-warning",
  class: "flex items-center gap-2 rounded-lg bg-yellow-lp-400 px-3 py-2 text-sm text-yellow-lp-500"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-4 w-4",
  alt: ""
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Only "),
  /*#__PURE__*/_createVNode("strong", null, "100"),
  /*#__PURE__*/_createTextVNode(" AWBs can be included in this pickup request. ")
], -1)
const _hoisted_19 = {
  key: 3,
  class: "w-full mb-4"
}
const _hoisted_20 = {
  key: 0,
  "data-testid": "pickup-request-modal-error-client",
  class: "text-xs text-red-lp-100 mt-1"
}
const _hoisted_21 = {
  class: "w-full",
  "data-testid": "pickup-request-modal-address-section"
}
const _hoisted_22 = { class: "flex items-center justify-between mb-3" }
const _hoisted_23 = { class: "text-sm font-semibold text-black-lp-300" }
const _hoisted_24 = {
  key: 0,
  class: "flex flex-col gap-1 text-sm border border-gray-lp-400 rounded-lg p-4"
}
const _hoisted_25 = { class: "flex items-center gap-2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "ics_f_location_pin"
}, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "px-2 bg-gray-lp-1400 rounded text-xs font-medium"
}
const _hoisted_28 = { class: "text-black-lp-300" }
const _hoisted_29 = { class: "font-bold text-black-lp-300" }
const _hoisted_30 = { class: "text-gray-lp-3000" }
const _hoisted_31 = { class: "text-gray-lp-3000" }
const _hoisted_32 = {
  key: 1,
  class: "flex flex-col items-center gap-2 py-4 border border-gray-lp-1500 rounded-lg"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "not-data-filter",
  width: "95",
  height: "80"
}, null, -1)
const _hoisted_34 = { class: "text-sm text-gray-lp-600" }
const _hoisted_35 = {
  key: 2,
  "data-testid": "pickup-request-modal-error-address",
  class: "text-xs text-red-lp-100 mt-1"
}
const _hoisted_36 = {
  key: 4,
  class: "flex flex-col p-2 rounded bg-gray-lp-1000 px-3 py-3 gap-2"
}
const _hoisted_37 = { class: "text-sm font-semibold" }
const _hoisted_38 = { class: "flex flex-wrap gap-2" }
const _hoisted_39 = {
  key: 0,
  class: "px-1 bg-red-lp-3100 rounded text-xs text-red-lp-2400"
}
const _hoisted_40 = {
  key: 1,
  class: "text-base leading-none"
}
const _hoisted_41 = { class: "flex flex-row gap-x-4 w-full" }
const _hoisted_42 = { class: "flex-1" }
const _hoisted_43 = { class: "flex-1" }
const _hoisted_44 = { class: "text-xs font-semibold text-black-lp-300 mb-2 block" }
const _hoisted_45 = { class: "flex flex-row gap-x-6" }
const _hoisted_46 = { class: "flex flex-row gap-x-4 w-full" }
const _hoisted_47 = { class: "flex-1" }
const _hoisted_48 = {
  key: 0,
  "data-testid": "pickup-request-modal-error-date",
  class: "text-xs text-red-lp-100 mt-1"
}
const _hoisted_49 = { class: "flex-1" }
const _hoisted_50 = {
  key: 0,
  "data-testid": "pickup-request-modal-error-time",
  class: "text-xs text-red-lp-100 mt-1"
}
const _hoisted_51 = {
  key: 0,
  "data-testid": "pickup-request-modal-error-service",
  class: "text-xs text-red-lp-100 mt-1"
}
const _hoisted_52 = { class: "flex flex-col items-end w-full gap-2" }
const _hoisted_53 = {
  key: 2,
  class: "relative z-50"
}
const _hoisted_54 = {
  key: 3,
  class: "relative z-50"
}
const _hoisted_55 = { class: "w-full flex flex-row items-center" }
const _hoisted_56 = { class: "w-36 mr-4" }
const _hoisted_57 = { class: "w-36" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TimeSlotDropdown = _resolveComponent("TimeSlotDropdown")!
  const _component_MultipleSelectProduct = _resolveComponent("MultipleSelectProduct")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_ModalSttPickupListDhl = _resolveComponent("ModalSttPickupListDhl")!
  const _component_ModalSttPickupList = _resolveComponent("ModalSttPickupList")!
  const _component_ModalAddNewAddress = _resolveComponent("ModalAddNewAddress")!
  const _component_SavedAddressList = _resolveComponent("SavedAddressList")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ModalV2, {
      title: _ctx.modalTitle,
      onClose: _ctx.onClose,
      width: "w-800px",
      showBorderTitle: true,
      titlePadding: 'px-6 py-4',
      contentPadding: 'px-6 pt-3 pb-0',
      footerPadding: 'px-6 py-4',
      marginHeader: 'mb-0',
      marginFooter: 'mt-0',
      isShadows: false,
      isRoundedLg: true,
      showFooter: true,
      footerBgColor: 'bg-white',
      borderTop: 'border-t border-gray-lp-400',
      closeButtonTestId: "pickup-request-modal-button-close"
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          (_ctx.formHandler.showBucketBanner)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t("pickup.requestModal.banner.sttPrefix")), 1),
                  _createVNode("strong", _hoisted_5, _toDisplayString(_ctx.form.sttCount) + " " + _toDisplayString(_ctx.shipmentLabel), 1),
                  _createVNode("span", null, _toDisplayString(_ctx.$t("pickup.requestModal.banner.sttSuffix")), 1)
                ]),
                _createVNode("button", {
                  "data-testid": "pickup-request-modal-link-view-all-stt",
                  class: "text-sm font-semibold text-red-lp-2400 whitespace-nowrap",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onViewAllStt && _ctx.onViewAllStt(...args)))
                }, _toDisplayString(_ctx.$t("pickup.requestModal.banner.viewAll")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.formHandler.showBucketBanner && _ctx.isDhlWhitelist)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode("button", {
                    "data-testid": "pickup-request-modal-awb-card-link-view-awb",
                    class: "text-xs font-semibold text-red-lp-100 whitespace-nowrap",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onViewAllStt && _ctx.onViewAllStt(...args)))
                  }, " View AWB ")
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.selectedSummary.awbCount) + " ", 1),
                    _hoisted_11
                  ]),
                  _createVNode("span", _hoisted_12, " (" + _toDisplayString(_ctx.selectedSummary.koliCount) + " pcs) ", 1),
                  _hoisted_13,
                  _createVNode("span", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.selectedSummary.weightKg) + " ", 1),
                    _hoisted_15
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.formHandler.showBucketBanner &&
                _ctx.isDhlWhitelist &&
                _ctx.selectedSummary.awbCount > 100
            )
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _hoisted_17,
                _hoisted_18
              ]))
            : _createCommentVNode("", true),
          (_ctx.isInternalAccount)
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('pickup.requestModal.field.clientLabel'),
                  asterisk: "",
                  class: "w-full",
                  "border-failed": !!_ctx.form.errors.client
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      placeholder: 
                  _ctx.$t('pickup.requestModal.field.clientPlaceholder')
                ,
                      class: "mt-2",
                      keyName: "clientName",
                      keyValue: "clientId",
                      "model-value": _ctx.formHandler.selectedClient || '',
                      options: _ctx.clientOptions,
                      "is-loading": _ctx.clientSearchLoading,
                      "max-height": "300px",
                      maxLength: 1000,
                      useInfiniteScroll: "",
                      onFocus: _ctx.onClientSearchFocus,
                      onFilter: _ctx.onClientSearchFilter,
                      onScrolled: _ctx.onClientSearchScrolled,
                      onChange: _ctx.onClientSelect
                    }, null, 8, ["placeholder", "model-value", "options", "is-loading", "onFocus", "onFilter", "onScrolled", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label", "border-failed"]),
                (_ctx.form.errors.client)
                  ? (_openBlock(), _createBlock("div", _hoisted_20, _toDisplayString(_ctx.$t(_ctx.form.errors.client)), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("pickup.requestModal.field.addressLabel")), 1),
              _createVNode("button", {
                "data-testid": "pickup-request-modal-button-change-address",
                class: ["text-xs font-semibold text-red-lp-100 flex items-center gap-1", {
                  'text-gray-lp-600 cursor-not-allowed': !_ctx.isAllowedAddAddress
                }],
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openAddressList && _ctx.openAddressList(...args))),
                disabled: !_ctx.isAllowedAddAddress
              }, [
                _createTextVNode(_toDisplayString(_ctx.selectedAddress
                    ? _ctx.$t("pickup.requestModal.changeAddress")
                    : _ctx.$t("pickup.requestModal.addAddress")) + " ", 1),
                _createVNode(_component_Icons, {
                  name: "chevron-right",
                  class: "h-3"
                })
              ], 10, ["disabled"])
            ]),
            (_ctx.selectedAddress)
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _hoisted_26,
                    (_ctx.selectedAddress.pcaIsDefault)
                      ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(_ctx.$t("pickup.requestModal.address.mainBadge")), 1))
                      : _createCommentVNode("", true),
                    _createVNode("span", _hoisted_28, _toDisplayString(_ctx.selectedAddress.pcaName), 1),
                    _createVNode("span", _hoisted_29, _toDisplayString(_ctx.addressPicPhone), 1)
                  ]),
                  _createVNode("div", _hoisted_30, _toDisplayString(_ctx.addressFullAddress), 1),
                  _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("pickup.requestModal.address.coordinate", {
                    lat: _ctx.selectedAddress.pcaLatlon
                  })), 1)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("pickup.requestModal.addressEmpty")), 1)
                ])),
            (_ctx.form.errors.address)
              ? (_openBlock(), _createBlock("div", _hoisted_35, _toDisplayString(_ctx.$t(_ctx.form.errors.address)), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.formHandler.showRecoChips && _ctx.recommendationChips.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("pickup.requestModal.recommendationLabel")), 1),
                _createVNode("div", _hoisted_38, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recommendationChips, (chip, idx) => {
                    return (_openBlock(), _createBlock("button", {
                      key: idx,
                      "data-testid": `pickup-request-modal-reco-chip-${idx}`,
                      class: "px-3 py-1.5 bg-white rounded-lg text-sm cursor-pointer hover:bg-gray-lp-400 flex items-center gap-1.5",
                      onClick: ($event: any) => (_ctx.applyRecoChip(chip))
                    }, [
                      (_ctx.chipHasDG(chip))
                        ? (_openBlock(), _createBlock("span", _hoisted_39, " DG "))
                        : _createCommentVNode("", true),
                      (_ctx.chipHasDG(chip))
                        ? (_openBlock(), _createBlock("span", _hoisted_40, " · "))
                        : _createCommentVNode("", true),
                      _createVNode("span", null, _toDisplayString(_ctx.formatRecommendationChip(chip)), 1)
                    ], 8, ["data-testid", "onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_41, [
            _createVNode("div", _hoisted_42, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickup.requestModal.field.koliLabel'),
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.form.koli,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.koli = $event)),
                    "data-testid": "pickup-request-modal-input-koli",
                    disabled: _ctx.isDhlSttSelected,
                    placeholder: _ctx.$t('pickup.requestModal.field.koliPlaceholder'),
                    format: _ctx.formatIntegerInput,
                    error: !!_ctx.form.errors.koli,
                    "error-caption": 
                    _ctx.form.errors.koli ? _ctx.$t(_ctx.form.errors.koli) : ''
                  ,
                    onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.formHandler.markTouched('koli'))),
                    onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formHandler.validateField('koli')))
                  }, null, 8, ["modelValue", "disabled", "placeholder", "format", "error", "error-caption"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_43, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickup.requestModal.field.weightLabel'),
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.form.weight,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.weight = $event)),
                    "data-testid": "pickup-request-modal-input-weight",
                    disabled: _ctx.isDhlSttSelected,
                    placeholder: 
                    _ctx.$t('pickup.requestModal.field.weightPlaceholder')
                  ,
                    format: _ctx.formatIntegerInput,
                    error: !!_ctx.form.errors.weight,
                    "error-caption": 
                    _ctx.form.errors.weight ? _ctx.$t(_ctx.form.errors.weight) : ''
                  ,
                    suffix: "kg",
                    onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formHandler.markTouched('weight'))),
                    onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formHandler.validateField('weight')))
                  }, null, 8, ["modelValue", "disabled", "placeholder", "format", "error", "error-caption"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createVNode("div", null, [
            _createVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("pickup.requestModal.specialHandlingLabel")), 1),
            _createVNode("div", _hoisted_45, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.specialHandlingOptions, (sh) => {
                return (_openBlock(), _createBlock(_component_CheckboxV2, {
                  key: sh.key,
                  "data-testid": `pickup-request-modal-checkbox-${sh.testId}`,
                  label: sh.label,
                  value: _ctx.form.specialHandling[sh.key],
                  disabled: _ctx.formHandler.isInheritedSH(sh.key),
                  keyName: 'sh-' + sh.key,
                  "text-size": 14,
                  "label-weight": "normal",
                  "onUpdate:value": (val) => { _ctx.form.specialHandling[sh.key] = val }
                }, null, 8, ["data-testid", "label", "value", "disabled", "keyName", "onUpdate:value"]))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickup.requestModal.field.dateLabel'),
                asterisk: "",
                "border-failed": !!_ctx.form.errors.date
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DatePicker, {
                    class: "mt-2",
                    placeholder: "$t('pickup.requestModal.field.selectDatePlaceholder')",
                    "model-value": _ctx.form.date,
                    "data-testid": "pickup-request-modal-input-date",
                    "min-date": _ctx.minDate,
                    "onUpdate:modelValue": _ctx.onDateUpdate
                  }, null, 8, ["model-value", "min-date", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["label", "border-failed"]),
              (_ctx.form.errors.date)
                ? (_openBlock(), _createBlock("div", _hoisted_48, _toDisplayString(_ctx.$t(_ctx.form.errors.date)), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_49, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickup.requestModal.field.timeLabel'),
                asterisk: "",
                "border-failed": !!_ctx.form.errors.time
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TimeSlotDropdown, {
                    modelValue: _ctx.form.time,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.time = $event)),
                    times: _ctx.timeSlots,
                    "title-pickup": _ctx.$t('pickup.requestModal.timePlaceholder'),
                    class: "mt-2",
                    onOnSelect: _ctx.onTimeSelect
                  }, null, 8, ["modelValue", "times", "title-pickup", "onOnSelect"])
                ]),
                _: 1
              }, 8, ["label", "border-failed"]),
              (_ctx.form.errors.time)
                ? (_openBlock(), _createBlock("div", _hoisted_50, _toDisplayString(_ctx.$t(_ctx.form.errors.time)), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickup.requestModal.field.serviceLabel'),
              optional: "",
              "border-failed": !!_ctx.form.errors.serviceCodes
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MultipleSelectProduct, {
                  modelValue: _ctx.form.serviceCodes,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.serviceCodes = $event)),
                  "data-testid": "pickup-request-modal-select-service",
                  status: "active",
                  placeholder: 
                  _ctx.$t('pickup.requestModal.field.servicePlaceholder')
                ,
                  disabledJumboPackH2h: "true",
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.errors.serviceCodes = ''))
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "border-failed"]),
            (_ctx.form.errors.serviceCodes)
              ? (_openBlock(), _createBlock("div", _hoisted_51, _toDisplayString(_ctx.$t(_ctx.form.errors.serviceCodes)), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('pickup.requestModal.field.courierNoteLabel'),
            optional: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.form.courierNote,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.courierNote = $event)),
                "data-testid": "pickup-request-modal-input-courier-note",
                placeholder: 
                _ctx.$t('pickup.requestModal.field.courierNotePlaceholder')
              ,
                type: "textarea",
                "text-area-rows": "2",
                "max-length": 255,
                "show-max-length": ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_52, [
          _createVNode(_component_button_fill, {
            "data-testid": "pickup-request-modal-button-submit",
            title: _ctx.$t('pickup.requestModal.submit'),
            class: "bg-red-lp-2400 px-8",
            "is-disabled": _ctx.isSubmitDisabled,
            "is-loading": _ctx.formHandler.isSubmitting,
            onClick: _ctx.handleSubmit
          }, null, 8, ["title", "is-disabled", "is-loading", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["title", "onClose"]),
    (_ctx.isDhlWhitelist)
      ? (_openBlock(), _createBlock(_component_ModalSttPickupListDhl, {
          key: 0,
          ref: "dhlSttPicker",
          modelValue: _ctx.showSttListModal,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.showSttListModal = $event)),
          "bkd-count": _ctx.form.sttCount,
          onSelectionChange: _ctx.onSelectionChange
        }, null, 8, ["modelValue", "bkd-count", "onSelectionChange"]))
      : (_openBlock(), _createBlock(_component_ModalSttPickupList, {
          key: 1,
          modelValue: _ctx.showSttListModal,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.showSttListModal = $event)),
          "bkd-count": _ctx.form.sttCount
        }, null, 8, ["modelValue", "bkd-count"])),
    (_ctx.showAddFirstAddress)
      ? (_openBlock(), _createBlock("div", _hoisted_53, [
          _createVNode(_component_ModalAddNewAddress, {
            formType: "add",
            isVisible: _ctx.showAddFirstAddress,
            onClose: _ctx.closeAddFirstAddress,
            clientId: _ctx.formHandler?.selectedClient?.clientId || 0,
            forceDefault: true,
            onOnSuccess: _ctx.onAddFirstAddressSuccess
          }, null, 8, ["isVisible", "onClose", "clientId", "onOnSuccess"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSavedAddressListOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_54, [
          _createVNode(_component_SavedAddressList, {
            isShown: _ctx.isSavedAddressListOpen,
            "onUpdate:isShown": _cache[16] || (_cache[16] = ($event: any) => (_ctx.isSavedAddressListOpen = $event)),
            selectedAddress: _ctx.selectedAddress || _ctx.emptyAddress,
            onSelectAddress: _ctx.onSelectAddress,
            onUpdateDefaultAddress: _ctx.onAddressListChanged,
            onAddressDeleted: _ctx.onAddressListChanged
          }, null, 8, ["isShown", "selectedAddress", "onSelectAddress", "onUpdateDefaultAddress", "onAddressDeleted"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModalFailed)
      ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 4 }, _ctx.modalErrorMessageEntities), {
          "custom-button": _withCtx(() => [
            _createVNode("div", _hoisted_55, [
              _createVNode("div", _hoisted_56, [
                _createVNode(_component_button_outline, {
                  "is-width-full": "",
                  "font-bold": "",
                  title: _ctx.$t('pickup.requestModal.back'),
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showModalFailed = false))
                }, null, 8, ["title"])
              ]),
              _createVNode("div", _hoisted_57, [
                _createVNode(_component_lp_button, {
                  class: "text-white",
                  "is-width-full": "",
                  "font-bold": "",
                  title: _ctx.$t('pickup.requestModal.retry'),
                  onClick: _ctx.handleSubmit
                }, null, 8, ["title", "onClick"])
              ])
            ])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true)
  ]))
}